import config from '../../../../config/config';
import { Configuration, ProjectsModuleApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const projectApi = new ProjectsModuleApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
